import { createAction, props } from '@ngrx/store';

const actionPrefix = '[Dashboard] [Range]';

const resetRangeValues = createAction(`${actionPrefix} Reset Range Values`, props<{ shopId: number }>());

const setStartDateValue = createAction(
  `${actionPrefix} Set Start Date Value`,
  props<{ startDateValue: number; shopId: number }>(),
);

const setEndDateValue = createAction(
  `${actionPrefix} Set End Date Value`,
  props<{ endDateValue: number; shopId: number }>(),
);

const setIsLoading = createAction(`${actionPrefix} Set Is Loading`, props<{ isLoading: boolean }>());

export { resetRangeValues, setStartDateValue, setEndDateValue, setIsLoading };
